import { render, staticRenderFns } from "./ValueRating.vue?vue&type=template&id=c007f394&"
import script from "./ValueRating.vue?vue&type=script&lang=js&"
export * from "./ValueRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports